<div class="tw-w-full tw-flex-col tw-justify-center">
    <table
        class="overflow-x-auto"
        mat-table
        [dataSource]="dataSource"
        matSort
        (matSortChange)="sortData($event)"
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="tableDrop($event)">
        <!-- ID Column used to display icon buttons -->
        <ng-container matColumnDef="id">
            <th
                mat-header-cell
                *matHeaderCellDef>
                <button
                    mat-icon-button
                    (click)="toggleColumnSelectionMenu()">
                    <mat-icon fontSet="material-symbols-outlined"
                        >tune</mat-icon
                    >
                </button>
                @if (showColumSelection) {
                    <ng-container>
                        <mat-card
                            class="position-fixed z-3"
                            id="column-selection">
                            <button
                                mat-stroked-button
                                (click)="updateColumns()">
                                {{
                                    'ECMR.overview.columns_settings.configure_columns'
                                        | translate
                                }}
                                <mat-icon
                                    fontSet="material-symbols-outlined"
                                    color="primary"
                                    >close</mat-icon
                                >
                            </button>
                            <mat-checkbox
                                [checked]="showColumns.number"
                                (change)="toggleColumnAtKey('number')"
                                >{{
                                    'ECMR.template_overview.table_header.number'
                                        | translate
                                }}
                            </mat-checkbox>
                            <mat-checkbox
                                [checked]="showColumns.name"
                                (change)="toggleColumnAtKey('name')"
                                >{{
                                    'ECMR.template_overview.table_header.name'
                                        | translate
                                }}
                            </mat-checkbox>
                            <mat-checkbox
                                [checked]="showColumns.refId"
                                (change)="toggleColumnAtKey('refId')"
                                >{{
                                    'ECMR.overview.table_header.ref_id'
                                        | translate
                                }}
                            </mat-checkbox>
                            <mat-checkbox
                                [checked]="showColumns.from"
                                (change)="toggleColumnAtKey('from')"
                                >{{
                                    'ECMR.overview.table_header.from'
                                        | translate
                                }}
                            </mat-checkbox>
                            <mat-checkbox
                                [checked]="showColumns.to"
                                (change)="toggleColumnAtKey('to')"
                                >{{
                                    'ECMR.overview.table_header.to' | translate
                                }}
                            </mat-checkbox>
                            <div class="mx-auto">
                                <button
                                    mat-flat-button
                                    color="primary"
                                    class="m-3"
                                    (click)="updateColumns()">
                                    {{ 'ECMR.COMMON.APPLY' | translate }}
                                    <mat-icon
                                        fontSet="material-symbols-outlined"
                                        iconPositionEnd
                                        >check</mat-icon
                                    >
                                </button>
                            </div>
                        </mat-card>
                    </ng-container>
                }
            </th>
            <td
                id="icons"
                mat-cell
                *matCellDef="let templateUser; let i = index">
                <span>
                    @if (!isReadOnly()) {
                        <button
                            mat-icon-button
                            (click)="editTemplate(templateUser)"
                            matTooltip="{{
                                'ECMR.overview.tooltips.edit' | translate
                            }}">
                            <mat-icon fontSet="material-symbols-outlined"
                                >edit_note</mat-icon
                            >
                        </button>
                    }
                    @if (!isReadOnly()) {
                        <button
                            mat-icon-button
                            (click)="
                                deleteTemplate(templateUser);
                                $event.stopPropagation()
                            "
                            matTooltip="{{
                                'ECMR.overview.tooltips.delete_template'
                                    | translate
                            }}">
                            <mat-icon
                                fontSet="material-symbols-outlined"
                                color="warn"
                                >delete</mat-icon
                            >
                        </button>
                    }
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="number">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.template_overview.table_header.number' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let templateUser; let i = index">
                {{ templateUser.templateUserNumber }}
            </td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.template_overview.table_header.name' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let templateUser; let i = index">
                {{ templateUser.name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="refId">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.overview.table_header.ref_id' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let templateUser; let i = index">
                {{
                    templateUser.ecmr.ecmrConsignment
                        .referenceIdentificationNumber.value
                }}
            </td>
        </ng-container>

        <ng-container matColumnDef="from">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.overview.table_header.from' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let templateUser; let i = index">
                {{
                    templateUser.ecmr.ecmrConsignment.senderInformation
                        .senderCompanyName
                }}
            </td>
        </ng-container>

        <ng-container matColumnDef="to">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="mat-header-row">
                <div class="my-3">
                    <span class="float-start fw-bold">{{
                        'ECMR.overview.table_header.to' | translate
                    }}</span>
                    <br />
                </div>
            </th>
            <td
                mat-cell
                *matCellDef="let templateUser; let i = index">
                {{
                    templateUser.ecmr.ecmrConsignment.consigneeInformation
                        .consigneeCompanyName
                }}
            </td>
        </ng-container>
        <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns"></tr>
        <tr
            mat-row
            *matRowDef="let row; let i = index; columns: displayedColumns"
            id="rows"
            class="tw-cursor-pointer hover:tw-bg-gray-100"
            (click)="showDetailsForEcmrAtIndex(i)"></tr>
    </table>

    <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[20, 50, 100]"
        showFirstLastButtons></mat-paginator>
</div>
